var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDeactivateOperationsConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.812,
    viewBox: "0 0 90.161 71.812"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-deactivate-operations-confirm_svg__cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate-operations-confirm_svg__ICN_Modal_confirmare_Dezactivare_-_Operare_Enabled",
    "data-name": "ICN_Modal confirmare Dezactivare - Operare_Enabled",
    transform: "translate(-942.92 -396.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Path_948",
    d: "M44.5 13.39a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H6.926a4 4 0 01-3.465-6z",
    "data-name": "Path 948",
    transform: "translate(940 385)",
    fill: "#eaaa00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate-operations-confirm_svg__ICN_Modal_Confirmare_Dezactivare_Operare_Enabled",
    "data-name": "ICN_Modal Confirmare Dezactivare Operare_Enabled",
    transform: "translate(787.5 167.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Line_289",
    d: "M0 0h8.191",
    className: "kpmg-deactivate-operations-confirm_svg__cls-2",
    "data-name": "Line 289",
    transform: "translate(201.995 267.735)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate-operations-confirm_svg__Group_1426",
    "data-name": "Group 1426",
    transform: "translate(188.984 263.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Line_287",
    d: "M0 0h8.191",
    className: "kpmg-deactivate-operations-confirm_svg__cls-2",
    "data-name": "Line 287",
    transform: "translate(0 4.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Line_288",
    d: "M0 0h8.19",
    className: "kpmg-deactivate-operations-confirm_svg__cls-2",
    "data-name": "Line 288",
    transform: "rotate(90 2.047 2.048)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-deactivate-operations-confirm_svg__Group_1427",
    "data-name": "Group 1427",
    transform: "rotate(45 -229.302 387.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Line_287-2",
    d: "M0 0h8.19",
    className: "kpmg-deactivate-operations-confirm_svg__cls-2",
    "data-name": "Line 287",
    transform: "translate(0 4.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Line_288-2",
    d: "M0 0h8.19",
    className: "kpmg-deactivate-operations-confirm_svg__cls-2",
    "data-name": "Line 288",
    transform: "rotate(90 2.047 2.048)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Line_290",
    d: "M0 0h8.191",
    className: "kpmg-deactivate-operations-confirm_svg__cls-2",
    "data-name": "Line 290",
    transform: "translate(188.984 280.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Line_291",
    d: "M0 0h8.191",
    className: "kpmg-deactivate-operations-confirm_svg__cls-2",
    "data-name": "Line 291",
    transform: "translate(188.984 284.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-deactivate-operations-confirm_svg__Line_292",
    d: "M0 26.688L21.978 0",
    className: "kpmg-deactivate-operations-confirm_svg__cls-2",
    "data-name": "Line 292",
    transform: "translate(188.5 260.5)"
  })))));
}

export default SvgKpmgDeactivateOperationsConfirm;